// extracted by mini-css-extract-plugin
module.exports = {"table":"Results_table__1LfOJ","head":"Results_head__lIcIQ","row":"Results_row__3NOw7","item":"Results_item__3t02t","empty":"Results_empty__1Njqh"};